import { render, staticRenderFns } from "./ComposerSearchWizard.vue?vue&type=template&id=1d67dab8&scoped=true"
import script from "./ComposerSearchWizard.vue?vue&type=script&lang=js"
export * from "./ComposerSearchWizard.vue?vue&type=script&lang=js"
import style0 from "./ComposerSearchWizard.vue?vue&type=style&index=0&id=1d67dab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d67dab8",
  null
  
)

export default component.exports